import React from 'react';

const SectionForm = ({
  section,
  onChange,
  onDelete,
  showDelete = false,
  index
}) => (
  <div className="section-edit-block" style={{ marginBottom: '10px'}}>
    <div className='form-section '>
       <label className='form-label'>Section Title</label>
    <input
      type="text"
      value={section.section_title || ''}
      onChange={e => onChange('section_title', e.target.value, index)}
      className="form-input form-control mb-1"
      placeholder="Section Title"
    />
    </div>
    <div className='form-section '>
      <label className='form-label'>Content Scope</label>
    <textarea
      value={section.content_scope || ''}
      onChange={e => onChange('content_scope', e.target.value, index)}
      className="form-input form-control mb-1"
      placeholder="Content Scope"
    />
    </div>
    <div className='form-section '>
       <label className='form-label'>Focus Keywords (comma separated)</label>
    <input
      type="text"
      value={Array.isArray(section.focus_keywords) ? section.focus_keywords.join(', ') : ''}
      onChange={e => onChange('focus_keywords', e.target.value.split(',').map(s => s.trim()), index)}
      className="form-input form-control mb-1"
      placeholder="Focus Keywords (comma separated)"
    />
    </div>
    <div className='form-section '>
      <label className='form-label'>Intent</label>
    <input
      type="text"
      value={section.intent || ''}
      onChange={e => onChange('intent', e.target.value, index)}
      className="form-input form-control mb-1"
      placeholder="Intent"
    />
    </div>
    <div className='form-section '>
        <label className='form-label'>Word Target</label>
    <input
      type="number"
      value={section.word_target || ''}
      onChange={e => onChange('word_target', Number(e.target.value), index)}
      className="form-input form-control mb-1"
      placeholder="Word Target"
    />
    </div>
    <div className='form-section '>
       <label className='form-label'>Format Type</label>
    <input
      type="text"
      value={section.format_type || ''}
      onChange={e => onChange('format_type', e.target.value, index)}
      className="form-input form-control mb-1"
      placeholder="Format Type"
    />
    </div>
    {showDelete && (
      <button
        onClick={() => onDelete(index)}
        className="btn btn-outline-primary mt-1"
      >
        Delete
      </button>
    )}
  </div>
);

export default SectionForm;
